// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XHB7","questions":"styles_questions__-TETk","footer":"styles_footer__o_ZGm"};